import {
  Container,
  Button,
  Typography,
  Grid,
  Divider,
  Stack,
  Grow,
} from '@mui/material'
import I18n from 'i18n-js'

import ShowMoreButton from '../shared/ShowMoreButton'

import { CampaignCardSkeleton } from './CampaignCard'
import { OmniCampaignCard, OmniCampaignCardProps } from './OmniCampaignCard'

type CampaignResultsContainerProps = {
  resetFilters: () => void
  showMoreHandler: () => void
  results: OmniCampaignCardProps[]
  isLoading: boolean
  totalResults: number
  pageSize: number
  noResultsText?: string
}
const CampaignResultsContainer: React.FC<
  React.PropsWithChildren<CampaignResultsContainerProps>
> = ({
  showMoreHandler,
  resetFilters,
  children,
  results,
  isLoading,
  totalResults,
  pageSize,
  noResultsText,
}) => {
  return (
    <Container maxWidth="lg">
      <Grid container justifyContent="center" columnSpacing={4} rowGap={12}>
        {results &&
          results.map((campaign, index: number) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
              key={`campaign-${campaign.id}`}
            >
              <Grow in>
                {/*
                Wrapping in a div works around some Transition quirks.
                https://github.com/mui/material-ui/issues/27154#issuecomment-1117386458
                */}
                <div>
                  <OmniCampaignCard {...campaign} />
                </div>
              </Grow>
            </Grid>
          ))}

        {isLoading &&
          Array.from({ length: pageSize }).map((_, i) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={4}
              key={`loading-card-${String(i)}`}
            >
              <CampaignCardSkeleton />
            </Grid>
          ))}
      </Grid>

      <Divider sx={{ marginY: 4 }} />

      {!isLoading && totalResults === 0 && (
        <Stack justifyContent="center">
          <Typography variant="subtitle1" textAlign="center">
            {noResultsText || I18n.t('content.noCampaignsFound')}
          </Typography>
          <Button size="medium" onClick={resetFilters}>
            {I18n.t('shared.resetSearch')}
          </Button>
        </Stack>
      )}

      {!isLoading && results.length < totalResults && totalResults !== 0 && (
        <ShowMoreButton
          numberShown={(results && results.length) || 0}
          onClick={showMoreHandler}
          total={totalResults}
        />
      )}

      {children}
    </Container>
  )
}

export default CampaignResultsContainer
